import React, {  useState,useEffect } from 'react';

function Page({analytics,analyticsCustom, h1, count, dimensions, questions, id, roomImgSrc, openCustomKit, commonText, defaultKit,getCurrentBestKit }) 
    {
    const imageRoot ='https://www.hp.com/content/dam/sites/worldwide/apps/presence-configurator/img/';
    //const imageRoot = process.env.PUBLIC_URL +'/img/'
    const [mobileOpen, setMobileOpen] = useState("closed")
    const [audioPos, setAudioPos] = useState("Front-of-room")
    const [cameraPos, setCameraPos] = useState("Yes")
    const [currentKit, setCurrentKit] = useState(defaultKit)
    const handleRadioButtonClicked = function (e) 
        {
        if (e.target.dataset.product === "Audio") { setAudioPos(e.currentTarget.value) }
        else if (e.target.dataset.product === "Camera") { setCameraPos(e.currentTarget.value) }
        /////////// animate products falling
        let products = document.querySelectorAll(  `#${e.target.dataset.roomname} .imageInner`   )
        for(let i=0; i< products.length; i++)
            {products[i].classList.add("isAnimated")}
        ///////////  remove animation after it has completed
        setTimeout(
            function() {
                for(let i=0; i< products.length; i++)
                {products[i].classList.remove("isAnimated")}
            }, 950);
        /////////////////////////////////////////////////////////////////////////////////////////////////// ANALYTICS
        // analytics("room-size", currentPage.replace("Size-",""), "01");
        // let roomNameTrim = e.target.dataset.roomname.replace("Size-","");
        // let productTrim  = e.target.dataset.product.replace("Size-","");

        // analytics(roomNameTrim + "-" + e.target.value,
        //           roomNameTrim + "-" + e.target.value,
        //           "02")
        }
    //
    const viewSolutionClick = function (e) 
        {
        e.preventDefault()
        let kitObject = [{ img: `${currentKit.img}`, title: `${currentKit.title}`, body: `${currentKit.body}`, hasButtons: true, datasheettxt:`${currentKit.datasheettxt}` }]

        if (currentKit.shopcta !== undefined)
            {
            kitObject = [{ img: `${currentKit.img}`, 
                        title: `${currentKit.title}`, 
                        body: `${currentKit.body}`, 
                        subcopy: `${currentKit.subcopy}`, 
                        productlist: `${currentKit.productsListTxt}`, 
                        shopcta: `${currentKit.shopcta}`, 
                        datasheethref: `${currentKit.datasheethref}`, 
                        datasheettxt:`${currentKit.datasheettxt}`,
                        shophref: `${currentKit.shophref}` }]
            /////////// ANALYTICS
            let roomSizeTrim = document.body.classList[0].replace("Size-","");
            // analyticsCustom(roomSizeTrim,"view-this-solution");
            }
        openCustomKit(kitObject,0);
        }
    //
    const showAllProductsForRoom = function (e) 
        {
        e.stopPropagation()
        const defaultProduct = e.target.dataset.defaultproduct; 
        openCustomKit(currentKit.products, defaultProduct);
        analytics( currentKit.title+">"+ e.target.alt, currentKit.title+">"+ e.target.alt)  /// analytics
        /////////// ANALYTICS
        let linkID = "0" + e.target.dataset.defaultproduct +"-"+ e.target.alt;
        // analyticsCustom('hotspots',linkID);
        }

    // Mobile drawer
    const openMobileDrawer = function () { setMobileOpen("open") ; document.body.classList.add("hasModalOpen")}
    const closeMobileDrawer = function (e) { e.preventDefault(); setMobileOpen("close") ; document.body.classList.remove("hasModalOpen")}

    // update best kit as soon as vals change
    useEffect(() => 
        {
        let newBestKit = getCurrentBestKit(id,cameraPos, audioPos)
        setCurrentKit( newBestKit )
        }, [cameraPos,audioPos,id]);




      

//////////////////////////////////////////////////////////////////////////////////////////////////////////////
    return (
        <section className={`page ${currentKit.cssClass}`} id={id}>
            <div className="page-inner">
                <h1 className="hasParallax" data-parastrength="0.3">{h1}</h1>
                <p className="hasParallax" data-parastrength=".1">{count}  {dimensions}</p>
                <div className="questionDrawerButton" onClick={openMobileDrawer}>{commonText.drawerButtontext}</div>
                <div className={`question-wrap ${mobileOpen}`}>
                    <div className="question-wrap-inner">
                    <div className="questionHeader">Customize your solution</div>
                        <div className="mobile">
                        <div className="close" onClick={closeMobileDrawer}>
                        <img src={`${imageRoot}icon-close.svg`} alt="close" />
                        </div>
                            <h2>{commonText.drawerButtontext}</h2>
                        </div>
                        <div className="question-set">
                            {questions.map((Q) => {
                                return (
                                    <div className="question" key={`${id}${Q.QID}`}>
                                        <div className="switch">
                                            {Q.answers.map((answer) =>
                                            (
                                                <div key={`${id}${Q.QID}${answer.id}`} >
                                                    <input type="radio"
                                                        value={answer.value}
                                                        id={`${id}${Q.QID}${answer.id}`}
                                                        name={`${Q.QID}${id}`}
                                                        onClick={handleRadioButtonClicked}
                                                        data-product={Q.QID}
                                                        data-roomname={id}
                                                    />
                                                    <label htmlFor={`${id}${Q.QID}${answer.id}`}>
                                                        {answer.text}
                                                    </label>
                                                </div>
                                            )
                                            )}
                                        </div>
                                    </div>
                                )
                            }
                            )}
                        </div>
                        <div className="mobile">
                            <a href="#" onClick={closeMobileDrawer}>{commonText.backButton}</a>
                            <hr />
                            <p>Once you’re ready, the next step is to view your solution overview.</p>
                        </div>
                        <button onClick={viewSolutionClick} data-roomname={h1}>{commonText.viewSolution}</button>
                    </div>
                </div>

            </div>
            <div className="imageOutter hasParallax" data-parastrength="0.2">
                    <div className="imageInner"  >
                        <img src={`${imageRoot}rooms/${roomImgSrc}`} alt={h1} draggable="false" />
                        {currentKit.products.map( (product,index)=>
                            {
                            return (
                                <div className={`roomObject ${product.cssClass}`} key={`${id}-${index}`}>
                                    <img src={`${imageRoot}thumbs2/${product.thumb}`} alt={product.title} draggable="false" onClick={showAllProductsForRoom} data-defaultproduct={index}/>
                                </div>
                                )
                            })}
                    </div>
                </div>
        </section>
    )
}
export default Page
